import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionModalComponent } from './action-modal.component';

@NgModule({
  declarations: [
    ActionModalComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [ActionModalComponent]
})
export class ActionModalModule { }
